import { labelForKey } from "@/lib/phone-json-labels";

/**
 * Arrays the phone runtime sorts by an item field, not JSON index.
 * Reordering the array in the editor does not change what the phone shows.
 */
const ARRAY_SORT_FIELD: Record<string, string> = {
  "device.apps.messages": "sent_at",
  "device.apps.messages_recently_deleted": "sent_at",
  "device.apps.whatsapp": "sent_at",
  "device.apps.notes": "created_at",
  "device.apps.gmail": "received_at",
  "device.apps.safari": "visited_at",
  "device.apps.calendar": "start_at",
  "device.apps.maps.visits": "visited_at",
  "device.apps.instagram": "posted_at",
  "device.apps.facebook": "posted_at",
  "device.apps.health": "day",
  "device.apps.airbnb.trips": "check_in_at",
  "device.apps.paypal.orders": "paid_at",
  "device.apps.photos.photos": "taken_at",
  "device.apps.photos.screenshots": "taken_at",
  "device.apps.photos.videos": "taken_at",
  "device.apps.photos.hidden": "taken_at",
  "device.apps.photos.recently_deleted": "taken_at",
  "canon.world.weather": "day",
  "canon.people": "name",
};

export function sortFieldForArrayPath(arrayPath: string): string | null {
  return ARRAY_SORT_FIELD[arrayPath] ?? null;
}

export function isSortField(arrayPath: string, fieldKey: string): boolean {
  return sortFieldForArrayPath(arrayPath) === fieldKey;
}

export function sortOrderHintText(field: string): string {
  const label = labelForKey(field);
  return `手机端按「${label}」(${field}) 排序，上下移动不会改变显示。请改该字段。`;
}
